import { useState } from "react";
import PreCSS from "../../src/utils/preRenderCSS";

import axios from "axios";
import Interweave from "interweave";
import { convertDate, ptToVwConverter } from "../../src/utils";

import { Dialog, Button } from "@material-ui/core";
import {
  TopContentsContainer,
  TopContentsTitleContainer,
  TopContentsTitle,
  DecorationLine,
} from "../../src/components/style";
import {
  NewsContainer,
  RightContainer,
  Title,
  SubTitle,
  MainImage,
  BodyWrapper,
} from "../../src/components/style/news";

import ShareButtons from "../../src/components/ShareButtons";
import BackToList from "../../src/components/BackToList";
import GridPics from "../../src/components/GridPics";

import i18next from "../../i18n";
import useWindowSize from "../../src/utils/useWindowSize";
import Head from "next/head";

const Post = ({
  article,
  next,
  previous,
  lang,
  id,
}: {
  article: News;
  next: string;
  previous: string;
  lang: string;
  id: string;
}) => {
  const windowSize = useWindowSize();

  if (!lang) {
    setTimeout(() => {
      if (!lang) {
        if (!i18next.i18n.languages.length) {
          i18next.i18n.languages = ["ja", "en"];
        }
        i18next.i18n.changeLanguage(
          i18next.i18n.language || i18next.i18n.languages[0] || "ja"
        );
      }
    }, 1000);
  }

  const subImages = [];
  if (article.img1) {
    subImages.push(article.img1);
  }
  if (article.img2) {
    subImages.push(article.img2);
  }
  if (article.img3) {
    subImages.push(article.img3);
  }
  if (article.img4) {
    subImages.push(article.img4);
  }

  const [open, setOpen] = useState(false);
  const [modalImg, setModalImg] = useState("");
  const [selected, setSelected] = useState("");
  const openDialog = (img: string) => {
    setOpen(true);
    setModalImg(img);
  };
  const handleClose = () => {
    setOpen(false);
    setModalImg("");
    setSelected(selected);
  };

  return (
    <div>
      <Head>
        <title>{article.title}</title>
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.title} />
        <meta property="og:image" content={article.imgMain?.url} />
        <meta property="og:url" content={`https://zero-dance.com/news/${id}`} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <PreCSS />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="profile_pic"
        maxWidth="lg"
      >
        <img
          src={modalImg}
          alt="modal"
          onContextMenu={(e) => {
            e.preventDefault();
            return false;
          }}
          style={{
            objectFit: "contain",
            width: "100%",
          }}
        />
      </Dialog>

      <NewsContainer>
        <TopContentsContainer>
          {windowSize === "desktop" ? (
            <>
              <TopContentsTitleContainer>
                <TopContentsTitle>news</TopContentsTitle>
              </TopContentsTitleContainer>
              <DecorationLine />
            </>
          ) : windowSize === "mobile" || windowSize === "tablet" ? (
            <>
              <div
                style={{
                  fontSize: "18px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  fontWeight: 400,
                }}
              >
                news
              </div>
              <DecorationLine />
            </>
          ) : (
            <p></p>
          )}

          <RightContainer>
            <Title>
              {lang === "ja"
                ? article.title
                : lang === "en"
                ? article.titleEng
                : ""}
            </Title>
            <SubTitle>
              {lang === "ja"
                ? article.subTitle
                : lang === "en"
                ? article.subTitleEng
                : ""}
            </SubTitle>
            <SubTitle>{`${
              lang === "ja" ? "掲載日" : lang === "en" ? "Published" : ""
            }: ${convertDate(article.publishedAt)}`}</SubTitle>
            {article.eventDate && (
              <SubTitle>
                {lang === "ja"
                  ? article.eventDate
                  : lang === "en"
                  ? article.eventDateEng
                  : ""}
              </SubTitle>
            )}

            {windowSize === "desktop" && (
              <Button
                style={{ padding: 0, margin: `${ptToVwConverter(40)}vw 0` }}
                aria-label="main image"
              >
                <MainImage
                  src={article.imgMain?.url}
                  alt={
                    lang === "ja"
                      ? article.title
                      : lang === "en"
                      ? article.titleEng
                      : ""
                  }
                  onContextMenu={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                  onClick={() =>
                    article.imgMain?.url && openDialog(article.imgMain.url)
                  }
                />
              </Button>
            )}

            <BodyWrapper>
              <Interweave
                content={
                  lang === "ja"
                    ? article.body
                    : lang === "en"
                    ? article.bodyEng
                    : ""
                }
              />
            </BodyWrapper>

            <GridPics subImages={subImages} />

            <ShareButtons />

            <BackToList main="news" previous={previous} next={next} />
          </RightContainer>
        </TopContentsContainer>
      </NewsContainer>
    </div>
  );
};

export async function getStaticPaths() {
  const baseURL = process.env.MICRO_URL;

  const newsURL = baseURL + "news?limit=1000";

  const config = {
    headers: {
      "X-API-KEY": process.env.MICRO_API_KEY,
    },
  };

  const newsResponse: NewsResponse = await axios.get(newsURL, config);

  const paths = newsResponse.data.contents.map((news) => `/news/${news.id}`);

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps(context: { params: { id: string } }) {
  const baseURL = process.env.MICRO_URL;

  const newsURL = baseURL + "news?limit=1000";

  const config = {
    headers: {
      "X-API-KEY": process.env.MICRO_API_KEY,
    },
  };

  const { id } = context.params;

  const all: NewsResponse = await axios.get(`${newsURL}`, config);

  const articles = all.data.contents.sort((a, b) => {
    const recent = new Date(a.publishedAt).getTime();
    const old = new Date(b.publishedAt).getTime();
    return old - recent;
  });

  // tslint:disable-next-line: one-variable-per-declaration
  let article, next, previous;
  articles.forEach((each, i) => {
    if (each.id === id) {
      article = each;
      if (articles[i - 1]) {
        previous = articles[i - 1].id;
      } else {
        previous = "";
      }
      if (articles[i + 1]) {
        next = articles[i + 1].id;
      } else {
        next = "";
      }
    }
  });

  return {
    props: {
      article,
      next,
      previous,
      namespacesRequired: [],
      id,
    },
  };
}

export default Post;
